import {Injectable} from '@angular/core';
import Swal from 'sweetalert2';
import {NgxSpinnerService} from "ngx-spinner";

@Injectable({
    providedIn: 'root'
})
export class CustomUiService {
    loaderMessage = 'Loading ...';

    constructor(private spinner: NgxSpinnerService) {
    }


    confirmAndSwitch(options: {
        title?: string;
        text?: string;
        icon?: 'success' | 'warning' | 'error' | 'info' | 'question';
        confirmText?: string;
        cancelText?: string;
        background?: string;
        color?: string;
        confirmButtonColor?: string;
        cancelButtonColor?: string;
        iconColor?: string;
        allowOutsideClick?: boolean;
        allowEscapeKey?: boolean;
        position?: string;
    }): Promise<boolean> {
        return Swal.fire({
            title: options.title,
            text: options.text,
            icon: options.icon,
            showCancelButton: true,
            confirmButtonText: options.confirmText,
            cancelButtonText: options.cancelText,
            background: options.background || '#fff',
            color: options.color,
            confirmButtonColor: options.confirmButtonColor ?? '#4caf50',
            cancelButtonColor: options.cancelButtonColor ?? '#f44336',
            iconColor: options.iconColor,
            allowOutsideClick: options.allowOutsideClick ?? true,
            allowEscapeKey: options.allowEscapeKey ?? true,
        }).then(result => result.isConfirmed);
    }

// Toast instance
    private toastSwal = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        showCloseButton: true,
        timerProgressBar: true
    });

    showLoader(message: string = 'Loading ...') {
        this.loaderMessage = message;
        this.spinner.show();
    }

    hideLoader() {
        this.spinner.hide();
    }

// Show toast
    showToast(
        message: string,
        title: string = 'Success',
        icon: 'success' | 'warning' | 'error' | 'info' = 'success',
        position: 'top' | 'top-start' | 'top-end' | 'center' | 'center-start' | 'center-end' | 'bottom' | 'bottom-start' | 'bottom-end' = 'top-end',
        timer: boolean | number = true,
        background?: string,
        color?: string,
        iconColor?: string
    ) {
        const defaults = this.setToastColors(icon);

        let timerValue: number | undefined;
        if (typeof timer === 'boolean') {
            timerValue = timer ? 3000 : undefined;
        } else {
            timerValue = timer;
        }

        this.toastSwal.fire({
            icon,
            title,
            text: message,
            position,
            timer: timerValue,
            background: background || defaults.background,
            color: color || defaults.color,
            iconColor: iconColor || defaults.iconColor,
        });
    }


    setToastColors(icon: 'success' | 'warning' | 'error' | 'info') {
        switch (icon) {
            case 'success':
                return {
                    background: '#4caf50', // Green
                    color: '#ffffff',
                    iconColor: '#ffffff',
                };
            case 'error':
                return {
                    background: '#f44336', // Red
                    color: '#ffffff',
                    iconColor: '#ffffff',
                };
            case 'warning':
                return {
                    background: '#ff9800', // Orange
                    color: '#000000',
                    iconColor: '#000000',
                };
            case 'info':
                return {
                    background: '#2196f3', // Blue
                    color: '#ffffff',
                    iconColor: '#ffffff',
                };
            default:
                return {
                    background: '#333333',
                    color: '#ffffff',
                    iconColor: '#ffffff',
                };
        }
    }
}